export default [
  {
    url: '/back',
    name: '분야 바로가기',
    icon: 'ArrowLeftIcon',
    activeCode: '',
  },
  {
    url: '/home',
    name: '대시보드',
    icon: '',
    activeCode: '',
  },
  {
    url: '/',
    name: '시스템 계약 현황',
    icon: '',
    activeCode: '',
    submenu: [
      {
        url: '/tab/118/page',
        name: '계약정보',
        icon: 'w-line',
        activeCode: '',
        groupName: ['118'],
      },
      {
        url: '/tab/105',
        name: '수급업체 등록 요청',
        icon: 'w-line',
        activeCode: '',
        groupName: ['105'],
      },
    ]
  },
  {
    url: '/',
    name: '신규 사업장 등록 요청',
    icon: '',
    activeCode: '',
    submenu: [
      // {
      //   url: '/tab/300',
      //   name: '직접수행 사업장',
      //   icon: 'w-line',
      //   activeCode: '',
      //   groupName: ['300'],
      // },
      // {
      //   url: '/tab/301',
      //   name: '도급·용역·위탁 사업장',
      //   icon: 'w-line',
      //   activeCode: '',
      //   groupName: ['301'],
      // },
      {
        url: '/tab/302',
        name: '발주 사업장',
        icon: 'w-line',
        activeCode: '',
        groupName: ['302'],
      },
    ]
  },
  {
    url: '/',
    name: '사업장/시설물 현황',
    icon: '',
    activeCode: '',
    submenu: [
      {
        url: '/field/info/type-c',
        name: '발주 사업장',
        icon: 'w-line',
        activeCode: '',
      },
    ]
  },
  {
    url: '/',
    name: '안전보건조직체계',
    icon: '',
    activeCode: '',
    submenu: [
      {
        url: '/tab/285',
        name: '안전보건관리(총괄)책임자 선임',
        icon: 'w-line',
        activeCode: '',
        groupName: ['285'],
      },
      {
        url: '/tab/126',
        name: '안전보건 조직 체계도',
        icon: 'w-line',
        activeCode: '',
        groupName: ['126'],
      },
      // {
      //   url: '/company/info',
      //   name: '소속부서 및 담당업체 정보',
      //   icon: 'w-line',
      //   activeCode: 'company-info',
      // },
      // {
      //   url: '/tab/141',
      //   name: '안전보건 관련 인력',
      //   icon: 'w-line',
      //   activeCode: '',
      //   groupName: ['141'],
      // },
      // {
      //   url: '/tab/136',
      //   name: '안전보건 점검 인력',
      //   icon: 'w-line',
      //   activeCode: '',
      //   groupName: ['136'],
      // },
      {
        url: '/tab/299',
        name: '종사자 정보',
        icon: 'w-line',
        activeCode: '',
        groupName: ['299'],
      },
      // {
      //   url: '/tab/138',
      //   name: '비상 연락/지원 체계도',
      //   icon: 'w-line',
      //   activeCode: '',
      //   groupName: ['138'],
      // },
      {
        url: '/tab/304',
        name: '유관기관 비상연락망',
        icon: 'w-line',
        activeCode: '',
        groupName: ['304'],
      },
      // {
      //   url: '/tab/119',
      //   name: '안전보건관리 책임자 지정 외',
      //   icon: 'w-line',
      //   activeCode: '',
      //   groupName: ['119', '120', '121', '122', '123', '125'],
      // },
      {
        url: '/tab/140',
        name: '안전보건관리체계 구축 계획 승인(중대산업재해)',
        icon: 'w-line',
        activeCode: '',
        groupName: ['140'],
      },
    ]
  },
  {
    url: '/',
    name: '안전보건관리 현황',
    icon: '',
    activeCode: '',
    submenu: [
      {
        url: '/tab/137',
        name: '안전보건 점검 계획',
        icon: 'w-line',
        activeCode: '',
        groupName: ['137'],
      },
      {
        url: '/tab/109',
        name: '사업장 경영방침',
        icon: 'w-line',
        activeCode: '',
        groupName: ['109'],
      },
      {
        url: '/tab/143',
        name: '도급전 정보 제공',
        icon: 'w-line',
        activeCode: '',
        groupName: ['143'],
      },
      {
        url: '/tab/144',
        name: '안전보건대장 작성',
        icon: 'w-line',
        activeCode: '',
        groupName: ['144', '145', '146']
      },
      {
        url: '/tab/147',
        name: '설계변경 요청',
        icon: 'w-line',
        activeCode: '',
        groupName: ['147'],
      },
      {
        url: '/tab/148',
        name: '건설공사 기간 연장',
        icon: 'w-line',
        activeCode: '',
        groupName: ['148'],
      },
      {
        url: '/tab/130',
        name: '수행평가',
        icon: 'w-line',
        activeCode: '',
        groupName: ['129', '130'],
      },
      {
        url: '/tab/150',
        name: '안전보건 확보 의무',
        icon: 'w-line',
        activeCode: '',
        groupName: ['150'],
      },
      {
        url: '/tab/152',
        name: '산업안전보건위원회',
        icon: 'w-line',
        activeCode: '',
        groupName: ['152']
      },
      {
        url: '/tab/153',
        name: '노사협의체',
        icon: 'w-line',
        activeCode: '',
        groupName: ['153']
      },
    ]
  },
  {
    url: '/',
    name: '안전보건 예산',
    icon: '',
    activeCode: '',
    submenu: [
      {
        url: '/tab/_154/page',
        name: '부서별 안전보건 예산(B형)',
        icon: 'w-line',
        activeCode: '',
        groupName: ['154/page'],
      },
      {
        url: '/tab/154',
        name: '안전보건 예산(B형)',
        icon: 'w-line',
        activeCode: '',
        groupName: ['154'],
      },
    ]
  },
  {
    url: '/',
    name: '교육 현황',
    icon: '',
    activeCode: '',
    submenu: [
      {
        url: '/tab/107',
        name: '안전·보건 교육',
        icon: 'w-line',
        activeCode: '',
        groupName: ['107'],
      },
    ]
  },
  {
    url: '/',
    name: '유해·위험요인 관리',
    icon: '',
    activeCode: '',
    submenu: [
      {
        url: '/tab/108',
        name: '유해·위험요인 조사표',
        icon: 'w-line',
        activeCode: '',
        groupName: ['108', '156', '157', '158', '159', '305', '306'],
      },
      {
        url: '/tab/160',
        name: '유해·위험요인 점검(개선)사항 요청',
        icon: 'w-line',
        activeCode: '',
        groupName: ['160'],
      },
    ]
  },
  {
    url: '/',
    name: '위험성평가',
    icon: '',
    activeCode: '',
    submenu: [
      {
        url: '/tab/288',
        name: '[공통]현장순회점검일지(현업근로자 위험성평가)',
        icon: 'w-line',
        activeCode: '',
        groupName: ['288'],
      },
      {
        url: '/tab/161',
        name: '정기 위험성평가',
        icon: 'w-line',
        activeCode: '',
        groupName: ['161'],
      },
      {
        url: '/tab/162',
        name: '수시 위험성평가',
        icon: 'w-line',
        activeCode: '',
        groupName: ['162'],
      },
      {
        url: '/tab/151',
        name: '위험성평가협의회',
        icon: 'w-line',
        activeCode: '',
        groupName: ['151'],
      },
    ]
  },
  {
    url: "/",
    name: "안전작업계획(허가)",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/tab/246",
        name: "안전작업계획서(고위험작업)",
        icon: 'w-line',
        activeCode: "",
        groupName: ["246"],
      },
      {
        url: "/tab/257",
        name: "작업허가서",
        icon: 'w-line',
        activeCode: "",
        groupName: ["257"],
      },
    ],
  },
  {
    url: '/',
    name: '안전보건 점검',
    icon: '',
    activeCode: '',
    submenu: [
      {
        url: '/tab/163',
        name: '일일안전보건점검일지',
        icon: 'w-line',
        activeCode: '',
        groupName: ['163'],
      },
      {
        url: '/tab/100',
        name: '작업장 합동점검',
        icon: 'w-line',
        activeCode: '',
        groupName: ['100'],
      },
      {
        url: '/tab/289',
        name: '[공통]안전보건 순회점검표(사무실)',
        icon: 'w-line',
        activeCode: '',
        groupName: ['289'],
      },
      {
        url: '/tab/291',
        name: '[공통]안전 순회점검표(현장)',
        icon: 'w-line',
        activeCode: '',
        groupName: ['291'],
      },
      {
        url: '/tab/290',
        name: '[공통]보건 순회점검표(현장)',
        icon: 'w-line',
        activeCode: '',
        groupName: ['290'],
      },
      {
        url: '/tab/292',
        name: '[공통]근골격계 증상조사표(근로자)',
        icon: 'w-line',
        activeCode: '',
        groupName: ['292'],
      },
      {
        url: '/tab/293',
        name: '[공통]근골격계부담작업 체크리스트',
        icon: 'w-line',
        activeCode: '',
        groupName: ['293'],
      },
      {
        url: '/tab/219',
        name: '건설기계·장비별',
        icon: 'w-line',
        activeCode: '',
        groupName: ['219'],
      },
      {
        url: '/tab/112',
        name: '건설현장 일반관리',
        icon: 'w-line',
        activeCode: '',
        groupName: ['112'],
      },
      {
        url: '/tab/221',
        name: '공정별',
        icon: 'w-line',
        activeCode: '',
        groupName: ['221'],
      },
      {
        url: '/tab/216',
        name: '사고유형별',
        icon: 'w-line',
        activeCode: '',
        groupName: ['216', '217', '218'],
      },
      {
        url: '/tab/220',
        name: '위험작업별',
        icon: 'w-line',
        groupName: ['220'],
      },
    ]
  },
  {
    url: '/',
    name: '재해발생 대비 대책',
    icon: '',
    activeCode: '',
    submenu: [
      {
        url: '/tab/116/page',
        name: '(재해발생) 산업재해 발생 시 보고 절차 안내',
        icon: 'w-line',
        activeCode: '',
        groupName: ['116'],
      },
      {
        url: '/tab/238/page',
        name: '(재해발생) 비상조치 및 처리 절차 안내',
        icon: 'w-line',
        activeCode: '',
        groupName: ['238'],
      },
      {
        url: '/tab/239',
        name: '비상대피 훈련·교육·자체평가',
        icon: 'w-line',
        activeCode: '',
        groupName: ['239', '240', '241'],
      },
      {
        url: '/tab/242',
        name: '비상조치계획 수립',
        icon: 'w-line',
        activeCode: '',
        groupName: ['242'],
      }
    ]
  },
  {
    url: '/',
    name: '재해발생보고',
    icon: '',
    activeCode: '',
    submenu: [
      {
        url: '/tab/117',
        name: '산업재해조사표',
        icon: 'w-line',
        activeCode: '',
        groupName: ['117'],
      },
      {
        url: '/tab/244',
        name: '중대재해 발생 보고',
        icon: 'w-line',
        activeCode: '',
        groupName: ['244'],
      },
      {
        url: '/tab/245',
        name: '재발방지계획서',
        icon: 'w-line',
        activeCode: '',
        groupName: ['245'],
      },
    ]
  },
  {
    url: '/',
    name: '자료실',
    icon: '',
    activeCode: '',
    submenu: [
      {
        url: '/filelibrary/343',
        name: '자료실',
        activeCode: 'filelibrary-343',
        icon: 'w-line'
      },
    ]
  },
  {
    url: '/community',
    name: '커뮤니티',
    slug: 'community',
    icon: '',
    submenu: [
      {
        url: '/community/businessnews',
        name: '기관장 메세지',
        activeCode: 'community_businessnews',
        icon: 'w-line'
      },
      {
        url: '/community/healthinfo',
        name: '안전보건 주요 일정',
        activeCode: 'community_healthinfo',
        icon: 'w-line'
      },
      {
        url: '/community/unitbusinessnews',
        name: '구성원 요청사항',
        activeCode: 'community_unitbusinessnews',
        icon: 'w-line'
      },
      {
        url: '/community/qna',
        name: 'Q&A',
        activeCode: 'community_qna',
        icon: 'w-line'
      }
    ]
  },
  {
    url: '/mypage',
    name: '마이페이지',
    slug: 'safety',
    icon: '',
    submenu: [
      {
        url: '/mypage/workstatus',
        name: '업무현황',
        slug: '',
        icon: 'w-line'
      },
      {
        url: '/mypage/alert',
        name: '알림',
        slug: '',
        icon: 'w-line'
      },
      {
        url: '/',
        name: '결재관리',
        slug: '',
        icon: 'w-line',
        submenu: [
          {
            url: '/approval-request',
            name: '결재요청함',
            slug: '',
            icon: 'w-line'
          },
          {
            url: '/approval-await',
            name: '결재대기함',
            slug: '',
            icon: 'w-line'
          },
          {
            url: '/approval-process',
            name: '결재진행함',
            slug: '',
            icon: 'w-line'
          },
          {
            url: '/approval-complete',
            name: '완료문서함',
            slug: '',
            icon: 'w-line'
          },
          {
            url: '/approval-reject',
            name: '반려문서함',
            slug: '',
            icon: 'w-line'
          },
          {
            url: '/approval-reference',
            name: '참조/회람문서함',
            slug: '',
            icon: 'w-line'
          },
        ]
      },
      {
        url: '/',
        name: '설정',
        slug: '',
        icon: 'w-line',
        submenu: [
          {
            url: '/mypage/info-update',
            name: '개인정보변경',
            slug: '',
            icon: 'w-line'
          },
        ]
      }
    ]
  }
]
